import React, { useEffect } from "react";
import { fireGtmEvent } from "../../utils/googleAnalytics";
import storageService from "../../Services/storageService";

const Bot = ({ learKey }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://storage.googleapis.com/cdn_hotelzify/bundle.js";
    script.defer = true;
    document.body.appendChild(script);

    const removePoweredDiv = () => {
      const widget = document.getElementById("lear-ai-widget");

      if (widget && widget.shadowRoot) {
        const poweredDiv = widget.shadowRoot.querySelector(".powered");
        if (poweredDiv) {
          poweredDiv.remove();
        }
      }
    };

    // Use MutationObserver to wait for Shadow DOM to load
    const observer = new MutationObserver(() => {
      const widget = document.getElementById("lear-ai-widget");
      if (widget && widget.shadowRoot) {
        removePoweredDiv();
        observer.disconnect(); // Stop observing once the div is removed
      }
    });

    // Start observing the widget for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Cleanup the script and observer on component unmount
    return () => {
      document.body.removeChild(script);
      observer.disconnect();
    };
  }, [learKey]);
  const handleBotClick = () => {
    const source = storageService.get("source");
    if (!["bot9chatbot", "sterling_ads"].includes(source)) {
      storageService.set("old_source", source);
      localStorage.setItem("source", "bot9chatbot");
      storageService.set("source", "bot9chatbot");
    }
    fireGtmEvent("lear_clicked");
  };

  return (
    <div>
      <div
        id="lear-ai-widget"
        data-script-tag-id={learKey}
        style={{ position: "relative", zIndex: "99999" }}
        onClick={handleBotClick}
      ></div>
    </div>
  );
};

export default Bot;
